import request from '@/utils/request'
const BASE_URL = '/CarBrand'

export default {
    list(data) {
        return request({
            url: BASE_URL + '/List',
            method: 'post',
            data
        })
    },
    info(id) {
        return request({
            url: BASE_URL + '/Info',
            method: 'get',
            params: { id }
        })
    },
    save(data) {
        return request({
            url: BASE_URL + '/Save',
            method: 'post',
            data
        })
    },
    delete(data) {
        return request({
            url: BASE_URL + '/Delete',
            method: 'post',
            data
        })
    },
    getBrands() {
        return request({
            url: BASE_URL + '/GetBrands',
            method: 'get',
            params: {}
        })
    },
    getSeries(brand) {
        return request({
            url: BASE_URL + '/GetSeries',
            method: 'get',
            params: { brand }
        })
    },
    getManufactor(brand, series) {
        return request({
            url: BASE_URL + '/GetManufactor',
            method: 'get',
            params: { brand, series }
        })
    },
    getMaxSn() {
        return request({
            url: BASE_URL + '/GetMaxSn',
            method: 'get',
            params: {}
        })
    },
    import: "/api" + BASE_URL + "/Import",
}